import * as Sentry from '@sentry/browser';

export const isBase64String = (str: string): boolean => {
  const reg = /^data:image\/\w+;base64,/;
  return reg.test(str);
};
export const combineImage = ({ backUrl, frontUrl }: { backUrl: string; frontUrl: string }): Promise<string | Error> => {
  // 创建一个新的Image对象
  let img1 = new Image();
  let img2 = new Image();
  img1.crossOrigin = isBase64String(backUrl) ? 'anomymous' : 'use-credentials';
  img2.crossOrigin = isBase64String(frontUrl) ? 'anomymous' : 'use-credentials';
  // 设置图片的src
  img1.src = backUrl;
  img2.src = frontUrl;

  return new Promise((resolve, reject) => {
    // 确保两个图片都加载完成
    img1.onload = function () {
      img2.onload = function () {
        // 创建一个新的canvas元素
        let canvas = document.createElement('canvas') as HTMLCanvasElement | null;
        let ctx = canvas!.getContext('2d');
        if (!ctx) return reject(new Error('canvas获取失败'));
        if (img1.width === 0 || img1.height === 0) {
          Sentry.captureException(new Error(`合成预览图失败，原因：【底图加载失败】, ${backUrl}`));
          return reject(new Error(`合成预览图失败，原因：【底图加载失败】, ${backUrl}`));
        }
        if (img2.width === 0 || img2.height === 0) {
          Sentry.captureException(new Error(`合成预览图失败, 原因：【绘制图层加载失败】 ${frontUrl}`));
          return reject(new Error(`合成预览图失败, 原因：【绘制图层加载失败】 ${frontUrl}`));
        }
        // 设置canvas的大小为两个图片的大小之和
        canvas!.width = Math.max(img1.width, img2.width);
        canvas!.height = Math.max(img1.height, img2.height);

        // 计算绘制图片的起始位置
        const x1 = (canvas!.width - img1.width) / 2;
        const y1 = (canvas!.height - img1.height) / 2;

        // 在canvas上绘制两个图片
        ctx!.drawImage(img1, x1, y1, img1.width, img1.height);
        ctx!.drawImage(img2, 0, 0);

        canvas!.toBlob(function (blob: any) {
          //测试用
          // const link = document.createElement('a')
          // link.download = ''
          // link.href = URL.createObjectURL(blob)
          // link.click()
          //销毁canvas
          canvas = null;
          resolve(blob);
        }, 'image/png');
      };
      img2.onerror = function () {
        Sentry.captureException(new Error(`绘制图层加载失败: ${frontUrl}`));
        reject(new Error(`绘制图层加载失败: ${frontUrl}`));
      };
      img2.src = frontUrl;
    };
    img1.onerror = function () {
      Sentry.captureException(new Error(`底图加载失败: ${backUrl}`));
      reject(new Error(`底图加载失败: ${backUrl}`));
    };
    img1.src = backUrl;
  });
};
export const getUrl = (url: string | string[]): string => {
  if (Array.isArray(url)) {
    return url[0];
  }
  return url;
};
